import VuexPersistence from "vuex-persist";
import { Config } from "@/plugins/config";

export default new VuexPersistence({
  key: Config.LocalStorage,
  storage: window.localStorage,
  modules: ["authModule"],
});
